export const JOB_TYPE_FIELD: string = "jobType";
export const JOB_REFERENCE_FIELD: string = "reference";
export const JOB_LAST_MODIFIED_DATE_FIELD: string = "lastModifiedDate";
export const JOB_STATUS_FIELD: string = "jobStatus";